import React,{useState,useRef} from 'react';

function FileUpload(props) {

    const inputFileRef = useRef( null );
    const dropZoneRef = useRef( null );

    const {
        filesStatus,
        appFiles,
        setAppFiles
    } = props;

    const [dropZoneActive,setDropZoneActive] = useState(false);

    const preventDefaultDrag  = (e)=> {
        e.preventDefault();
        e.stopPropagation();
    }

    const dropped=(e)=>{
        e.preventDefault();
        e.stopPropagation();
        handleFile(e.dataTransfer.files);
    }

    const zoneActive =(e)=>{
        e.preventDefault();
        e.stopPropagation();
        setDropZoneActive(true);
    }

    const zoneNotActive =(e)=>{
        e.preventDefault();
        e.stopPropagation();
        const rect = dropZoneRef.current.getBoundingClientRect();
        if(e.clientY < rect.top || e.clientY >= rect.bottom || e.clientX < rect.left || e.clientX >= rect.right) {
            setDropZoneActive(false);
        }
    }

    const inputChanged = (e)=>{
        handleFile(e.target.files);
    }

    const getFilesSizes = (arr)=>{
        const reducer = (accumulator, currentValue) => accumulator + currentValue;
        return arr.map(file=>file.size).reduce(reducer);
    }

    const getFileExtension = (file)=>{
        const {name} = file;
        return name.substring(name.lastIndexOf('.')+1);
    }

    const handleFile = (files)=>{
        setDropZoneActive(false);
        const filesArr = Object.keys(files).map((key) => files[key]);
        const totalSize = (appFiles.length? getFilesSizes(appFiles) : 0) + getFilesSizes(filesArr);
        const totalSizeMB = totalSize / 1000000;
        if(totalSizeMB  >  300) {
            alert(abraStr.maxFileSize);
            return;
        }
        const allowedFileTypes = ["jpg", "jpeg", "png", "stl"];
        let filesExtensionsAllowed = true;
        filesArr.forEach(file=>{
            if(!allowedFileTypes.includes(getFileExtension(file))){
                filesExtensionsAllowed = false;
                alert(abraStr.allowedFiles);
            }
        })
        if(!filesExtensionsAllowed) return;
        setAppFiles(prevState=>[...prevState,...filesArr]);
    }

    const removeFile = (index)=>{
        setAppFiles(prevState=>{
            let newState = [...prevState];
            newState.splice(index,1);
            return newState;
        })
    }

    const triggerInput = ()=>{
        inputFileRef.current.click();
    }

    return (
        <div id="abra-drop-wrap">
            <p className='instructions'>{abraStr.uploadFiles}</p>
            <div
                id="abra-drop-zone"
                className={dropZoneActive? "active":""}
                onDrop={dropped}
                onDragEnd={preventDefaultDrag}
                onDragEnter={zoneActive}
                onDrag={preventDefaultDrag}
                onDragLeave={zoneNotActive}
                onDragStart={preventDefaultDrag}
                onDragOver={preventDefaultDrag}
                ref={dropZoneRef}
            >
                <input
                    type="file"
                    className="form-control"
                    multiple
                    onChange={inputChanged}
                    ref={inputFileRef}
                />
                <div className='icon'/>
                <p>
                    {`${abraStr.dragAndDrop} `}
                    <a
                        onClick={triggerInput}
                    >{abraStr.browse}</a>
                </p>
            </div>
            <div id='abra-uploaded-files'>
                <ul>
                    {appFiles.map((file,index)=>
                        <li>
                            <span
                                onClick={()=>{removeFile(index)}}
                            >X</span>
                            {file.name}
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
}

export default FileUpload;